import ShareCode from './ShareCode';

export default ShareCode;
